'use strict';

export function isSerializableRef(value) {
  return true;
}
export function createSerializable(value) {
  return value;
}
export function makeShareableCloneOnUIRecursive(value) {
  return value;
}
export function makeShareable(value) {
  return value;
}
export function registerCustomSerializable(_registrationData) {
  // noop
}
//# sourceMappingURL=serializable.js.map